var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.25 3.75 17.5 13.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.7 10.381-1.875-4.375a.625.625 0 0 0-.575-.381h-1.875v-1.25a.625.625 0 0 0-.625-.625H1.875a.625.625 0 0 0-.625.625V15c0 .345.28.625.625.625h1.337a2.5 2.5 0 0 0 4.825 0h3.925a2.5 2.5 0 0 0 4.826 0h1.337c.345 0 .625-.28.625-.625v-4.375a.622.622 0 0 0-.05-.244Zm-4.325-3.506h1.463L17.175 10h-2.8V6.875Zm-8.75 9.375a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm6.338-1.875H8.038a2.5 2.5 0 0 0-4.825 0H2.5V5h10.625v7.85a2.5 2.5 0 0 0-1.162 1.525Zm2.412 1.875a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm3.125-1.875h-.712a2.5 2.5 0 0 0-2.413-1.875v-1.25H17.5v3.125Z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.8ac6ceb278d9bdb1bb3a64d1ea19f956.svg";
export { ForwardRef as ReactComponent };